import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { buildApiUrl } from "../../config/api";

function ProtectedAdminRoute({ children }) {
  const location = useLocation();
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    let isMounted = true;

    async function checkAdmin() {
      try {
        const response = await fetch(buildApiUrl("/admin/auth/me"), {
          method: "GET",
          credentials: "include",
          headers: {
            Accept: "application/json",
          },
        });

        if (!isMounted) return;

        if (response.ok) {
          setStatus("allowed");
        } else {
          setStatus("blocked");
        }
      } catch {
        if (isMounted) setStatus("blocked");
      }
    }

    checkAdmin();

    return () => {
      isMounted = false;
    };
  }, []);

  if (status === "checking") {
    return (
      <div className="admin-auth-loading">
        <div>
          <strong>MayaChitro</strong>
          <span>Checking admin access...</span>
        </div>
      </div>
    );
  }

  if (status === "blocked") {
    return (
      <Navigate
        to={`/admin-login?redirect=${encodeURIComponent(location.pathname)}`}
        replace
      />
    );
  }

  return children;
}

export default ProtectedAdminRoute;
